export default __webpack_public_path__ + "static/media/search.7fed7eae.svg";